// extracted by mini-css-extract-plugin
module.exports = {"status":"Status_status__3eTnA","icon":"Status_icon__jh-8g"};